import axios from 'axios'
import copy from 'fast-copy'

import {
	CHAT_OPENED,
	CHAT_TOGGLED,
	CHAT_CLOSED,
	CHAT_ADDED_USER,
	CHAT_RENAMED,
} from './types'

import { API_URL } from '../api'

export function createOrReturnChat(chat, user = null, callback = null, keepShut = false, replacingIndex = null) {
	return dispatch => {
		let optimisticResponse = false

		if (chat && chat.id) {
			optimisticResponse = true

			dispatch({
				type: CHAT_OPENED,
				payload: chat,
				isOpen: !keepShut,
				replacingIndex
			});

			if (callback) {
				callback(chat)
			}
		}

		axios.post(API_URL + '/chats/createOrReturn', { chat, user }).then(response => {
			// live sockets will fire on dev too...
			if (response.data) {
				if (user) {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: {
							id: user.id,
							chats: [response.data]
						},
						entityType: 'user',
					})
				} else {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: response.data,
						entityType: 'chat',
					})
				}

				if (!optimisticResponse) {
					dispatch({
						type: CHAT_OPENED,
						payload: response.data,
						isOpen: true,
						replacingIndex
					})

					if (callback) {
						callback(response.data)
					}
				}
			}
		}).catch(error => {
			console.log(error)
		})
	}
}

export function createOrReturnAssistantChat(accountId, callback = null) {
	return dispatch => {
		axios.post(API_URL + '/chats/createOrReturnAssistant', {
			accountId
		}).then(response => {
			if (response.data) {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'chat',
				})

				if (callback) {
					callback(response.data)
				}
			}
		}).catch(error => {
			console.log(error)
		})
	}
}

export function fetchMoreMessages(chatId, offset, fetchedAllResponse) {
	return dispatch => {
		axios.get(API_URL + '/chats/fetchMore?id=' + chatId + '&offset=' + offset).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data.chat,
				entityType: 'chat',
			})

			fetchedAllResponse(!response.data.isMore)
		})
	}
}

export function changeTempChatId(index, tempId, originalId = null) {
	return dispatch => {
		dispatch({
			type: 'CHAT_TEMP_ID_CHANGED',
			payload: {
				index,
				tempId,
				originalId
			}
		})
	}
}

export const openChat = chat => {
	return dispatch => {
		dispatch({
			type: CHAT_OPENED,
			payload: chat,
			isOpen: false
		});
	}

}

export function addUserToChat(user, chat) {
	return dispatch => {
		dispatch({
			type: CHAT_ADDED_USER,
			chat,
			user
		})

		axios.post(API_URL + '/chats/addUser', { chat, user }).catch(error => {
			console.log(error)
		})
	}

}

export function toggleChat(index) {
	return dispatch => {
		dispatch({
			type: CHAT_TOGGLED,
			index: index
		})
	}

}

export function closeChat(chat, index, deleteOnly = false) {
	if (chat && !chat.chat_items.length) {
		axios.post(API_URL + '/chats/delete', { chat }).then(response => {
		}).catch(error => {
			console.log(error)
		})
	}

	return dispatch => {
		if (!deleteOnly) {
			dispatch({
				type: CHAT_CLOSED,
				index: index
			})
		}
	}
}

export function sendMessage(chat, message, onlineUsers = [], repliedMessageId = null, customSenderId = null, mentionIds = []) {
	return dispatch => {
		axios.post(API_URL + '/chats/sendMessage', {
			chat,
			message,
			onlineUsers,
			repliedMessageId,
			customSenderId,
			mentionIds
		}).then(response => {

		}).catch(error => {
			console.log(error)
		})
	}
}

export function handleSeen(item, user) {
	return dispatch => {
		let seenBy = item.item.seen_by

		if (!seenBy) {
			seenBy = [user.id]
		} else {
			seenBy.push(user.id)
		}

		let itemObject = copy(item.item)

		itemObject.seen_by = seenBy

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: itemObject,
			entityType: item.type,
		})

		axios.post(API_URL + '/chats/handleSeen', { itemObject }).catch(error => {
			console.log(error);
		})
	}
}

export function saveChatTitle(name, chat) {
	if (!name) {
		return
	}

	return dispatch => {
		axios.post(API_URL + '/chats/saveTitle', { name, chat })

		chat.name = name

		dispatch({
			type: CHAT_RENAMED,
			chat,
			name
		})
	}
}

export function setTyping(isTyping, chatId, accountId, userId) {
	return dispatch => {
		let accountChannel = window.Echo.join('account_' + accountId)

		setTimeout(_ => {
			accountChannel.whisper('typing', {
				isTyping,
				userId,
				accountId,
				chatId
			})
		}, 50);
	}
}

export function whisperBigChatOpenStatus(userId, isOpen) {
	const userChannel = window.Echo.join('user_' + userId)

	userChannel.whisper('setBigChatOpenStatus', {
		isOpen
	})
}

export function setFocus(chatId, accountId, userId) {
	return dispatch => {
		let accountChannel = window.Echo.join('account_' + accountId)

		accountChannel.whisper('focused', {
			chatId,
			userId
		})

		dispatch({
			type: 'FOCUS_SET',
			payload: {
				userId,
				chatId
			}
		})
	}
}

export const openTeamChat = (team, callback) => {
	return dispatch => {
		axios.post(API_URL + '/chats/createOrReturnTeam', { team }).then(response => {
			// live sockets will fire on dev too...
			const chat = response.data

			if (chat) {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: chat,
					entityType: 'chat',
				})

				dispatch({
					type: CHAT_OPENED,
					payload: chat,
					isOpen: true,
				})

				if (callback) {
					callback()
				}
			}
		}).catch(error => {
			console.log(error)
		})
	}
}

export const clearExtraMessages = chatObject => {
	return dispatch => {
		dispatch({
			type: 'MESSAGES_CLEARED',
			payload: chatObject
		})
	}
}

export const getChatVersions = (chatId, offset, callback) => {
	return dispatch => {

		axios.get(`${API_URL}/chats/getVersions?id=${chatId}&offset=${offset}`).then(({ data }) => {
			const {
				versions,
				totals
			} = data

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: {
					id: chatId,
					versions
				},
				entityType: 'chat',
			})

			callback(data)
		})
	}
}

export const getChatLinks = (chatId, offset, callback) => {
	return _ => {
		axios.get(`${API_URL}/chats/getLinks?id=${chatId}&offset=${offset}`).then(({ data }) => {
			callback(data)
		})
	}
}

export const searchChat = (chatId, term, callback) => {
	return dispatch => {
		axios.get(`${API_URL}/chats/search?id=${chatId}&term=${term}`).then(({ data }) => {
			dispatch({
				type: 'CHAT_SEARCH_RESULTS',
				payload: data
			})

			callback()
		})
	}
}

export const likeMessage = (message, user) => {
	return dispatch => {
		axios.post(API_URL + '/chats/messages/like', { message, user })

		dispatch({
			type: 'MESSAGE_LIKED',
			payload: {
				messageId: message.id,
				userId: user.id
			},
		});
	}
}

export const reactToMessage = (message, emoji, user) => {
	return dispatch => {
		axios.post(API_URL + '/chats/messages/react', { message: { id: message.id }, emoji })

		dispatch({
			type: 'MESSAGE_REACTED',
			payload: {
				messageId: message.id,
				userId: user.id,
				emoji
			},
		})
	}
}
